import { itemField, upper, type Row } from './context';

/** Saved per-creature preference; absent/lean rows retain the five-second Ask default. */
export function reactionConsentMode(reactor: Row, abilityId: string): 'ask' | 'auto' {
  const rows = Array.isArray(reactor.reaction_consents) ? reactor.reaction_consents : [];
  const saved = rows.find(row => row && upper(itemField(row, 'reaction_consent_ability_id')) === upper(abilityId)
    && Number(itemField(row, 'reaction_consent_deleted') ?? 0) === 0);
  return saved && itemField(saved, 'reaction_consent_mode') === 'auto' ? 'auto' : 'ask';
}
